const floatingContact = () => {
    if(document.querySelector('.stoof-floating-contact')){

    /*    document.addEventListener('scroll',() => {

            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                document.querySelector('.stoof-floating-contact').classList.add('stoof-floating-contact__show');


            } else {
                if (document.querySelector('.stoof-floating-contact').classList.contains('stoof-floating-contact__show')) {
                    document.querySelector('.stoof-floating-contact').classList.remove('stoof-floating-contact__show');
                }
            }
        })*/
        document.addEventListener('click', ev =>{
            if(!(ev.target.matches('.stoof-floating-contact-trigger') || ev.target.closest('.stoof-floating-contact-trigger'))) return;
            const parent = ev.target.closest('.stoof-floating-contact--holder');
            const grandParent = parent.parentElement;

            const toShow = parent.querySelector('.stoof-floating-contact--link');
            toShow.classList.toggle('stoof-load');
            toShow.classList.toggle('stoof-floating-contact--link__show');
            const allLinks = grandParent.querySelectorAll('.stoof-floating-contact--link');
            allLinks.forEach(link =>{
                if(link !== toShow){
                    link.classList.remove('stoof-floating-contact--link__show');
                    link.classList.add('stoof-load');
                }

            })

        })
    }
}
export default floatingContact;